var pluralize = function (word, amount) { return "".concat(word).concat(amount > 1 || !amount ? 's' : ''); };

export { pluralize as default };
//# sourceMappingURL=pluralize.esm.js.map
